import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Returns the currency ISO code for the currently active scope.
 * - agent / division_manager → their division's currency
 * - company_admin → selected division's currency, or the first division if "all" is selected
 * - super_admin → USD (cross-company; UI shows amounts as-is per company)
 */
export function useActiveCurrency() {
  const { user } = useAuth();
  const { data: divisions = [] } = useQuery({
    queryKey: ["divs"],
    queryFn: () => api.get("/divisions").then((r) => r.data),
    enabled: !!user && user.role !== "super_admin",
  });
  if (!user) return "SGD";
  if (user.role === "super_admin") return "USD";
  const selected = typeof window !== "undefined" ? localStorage.getItem("leadify_selected_division") : null;
  if (selected) {
    const d = divisions.find((x) => x.id === selected);
    if (d?.currency) return d.currency;
  }
  if (user.role === "company_admin") {
    return divisions[0]?.currency || "SGD";
  }
  const own = divisions.find((x) => x.id === user.division_id);
  return own?.currency || "SGD";
}
